import React from 'react'
import Background from 'components/Background'

const CreateTokenViewBackground = () => (
  <Background height="38vh" />
)
export default CreateTokenViewBackground
